/**
 * Japanese profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Japanese
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 135
 */

export const JA = {
  "metadata": {
    "name": "Japanese",
    "code": "ja",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 135
  },
  "words": [
    {
      "word": "馬鹿",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "バカ",
        "ばか",
        "baka",
        "baca",
        "b4ka"
      ],
      "case_sensitive": false,
      "context_notes": "Common mild insult meaning 'stupid' or 'idiot', widely used in anime/manga. Hiragana: ばか, Katakana: バカ, Kanji: 馬鹿, Romaji: baka",
      "target_type": "individual"
    },
    {
      "word": "馬鹿野郎",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "バカヤロウ",
        "ばかやろう",
        "bakayarou"
      ],
      "case_sensitive": false,
      "context_notes": "Stronger version meaning 'stupid bastard'. Hiragana: ばかやろう, Katakana: バカヤロウ, Kanji: 馬鹿野郎, Romaji: bakayarou",
      "target_type": "individual"
    },
    {
      "word": "大馬鹿",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "おおばか",
        "oobaka"
      ],
      "case_sensitive": false,
      "context_notes": "Intensified form meaning 'big idiot'. Hiragana: おおばか, Kanji: 大馬鹿, Romaji: oobaka",
      "target_type": "individual"
    },
    {
      "word": "馬鹿たれ",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ばかたれ",
        "bakatare"
      ],
      "case_sensitive": false,
      "context_notes": "Variant meaning 'stupid fool'. Hiragana: ばかたれ, Kanji: 馬鹿たれ, Romaji: bakatare",
      "target_type": "individual"
    },
    {
      "word": "糞",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "クソ",
        "くそ",
        "kuso",
        "kusso"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'shit' or 'damn', commonly used as intensifier. Hiragana: くそ, Katakana: クソ, Kanji: 糞, Romaji: kuso",
      "target_type": "general"
    },
    {
      "word": "クソ食らえ",
      "severity": 3,
      "categories": [
        "scatological",
        "insult"
      ],
      "variations": [
        "くそくらえ",
        "kuso kurae"
      ],
      "case_sensitive": false,
      "context_notes": "Strong insult meaning 'eat shit'. Hiragana: くそくらえ, Katakana: クソ食らえ, Romaji: kuso kurae",
      "target_type": "individual"
    },
    {
      "word": "クソ野郎",
      "severity": 3,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "くそやろう",
        "kusoyarou"
      ],
      "case_sensitive": false,
      "context_notes": "Compound profanity meaning 'piece of shit'. Hiragana: くそやろう, Katakana/Mixed: クソ野郎, Romaji: kusoyarou",
      "target_type": "individual"
    },
    {
      "word": "畜生",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "チクショウ",
        "ちくしょう",
        "chikushou",
        "chikushо"
      ],
      "case_sensitive": false,
      "context_notes": "Buddhist term meaning 'beast', used as curse word. Hiragana: ちくしょう, Katakana: チクショウ, Kanji: 畜生, Romaji: chikushou",
      "target_type": "general"
    },
    {
      "word": "阿呆",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "アホ",
        "あほう",
        "aho",
        "ahou"
      ],
      "case_sensitive": false,
      "context_notes": "Kansai dialect equivalent of 'baka', slightly stronger in Tokyo. Hiragana: あほう, Katakana: アホ, Kanji: 阿呆, Romaji: aho",
      "target_type": "individual"
    },
    {
      "word": "阿呆たれ",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "あほたれ",
        "ahotare"
      ],
      "case_sensitive": false,
      "context_notes": "Kansai variant meaning 'stupid fool'. Hiragana: あほたれ, Kanji: 阿呆たれ, Romaji: ahotare",
      "target_type": "individual"
    },
    {
      "word": "くたばれ",
      "severity": 3,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "クタバレ",
        "kutabare"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar command meaning 'drop dead' or 'croak'. Hiragana: くたばれ, Katakana: クタバレ, Romaji: kutabare",
      "target_type": "individual"
    },
    {
      "word": "ざけんな",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "zakenna"
      ],
      "case_sensitive": false,
      "context_notes": "Aggressive phrase meaning 'bullshit' or 'don't mess with me'. Hiragana: ざけんな, Romaji: zakenna",
      "target_type": "individual"
    },
    {
      "word": "ふざけるな",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "fuzakeru na",
        "ふざけんな",
        "fuzaken na"
      ],
      "case_sensitive": false,
      "context_notes": "Command meaning 'don't mess with me' or 'stop joking around'. Hiragana: ふざけるな/ふざけんな, Romaji: fuzakeru na",
      "target_type": "individual"
    },
    {
      "word": "間抜け",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "マヌケ",
        "まぬけ",
        "manuke"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'fool' or 'clueless'. Hiragana: まぬけ, Katakana: マヌケ, Kanji: 間抜け, Romaji: manuke",
      "target_type": "individual"
    },
    {
      "word": "ボケ",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ぼけ",
        "boke"
      ],
      "case_sensitive": false,
      "context_notes": "Kansai term meaning 'fool' or 'stupid', used in comedy. Hiragana: ぼけ, Katakana: ボケ, Romaji: boke",
      "target_type": "individual"
    },
    {
      "word": "とんま",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "トンマ",
        "tonma"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'blockhead' or 'fool'. Hiragana: とんま, Katakana: トンマ, Romaji: tonma",
      "target_type": "individual"
    },
    {
      "word": "おたんこなす",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "オタンコナス",
        "otankonasu"
      ],
      "case_sensitive": false,
      "context_notes": "Playful insult meaning 'dummy' or 'birdbrain'. Hiragana: おたんこなす, Katakana: オタンコナス, Romaji: otankonasu",
      "target_type": "individual"
    },
    {
      "word": "能無し",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "のうなし",
        "nounashi"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'incompetent' or 'useless'. Hiragana: のうなし, Kanji: 能無し, Romaji: nounashi",
      "target_type": "individual"
    },
    {
      "word": "脳足りん",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "のうたりん",
        "nou tarin"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'brainless' or 'not enough brains'. Hiragana: のうたりん, Kanji: 脳足りん, Romaji: nou tarin",
      "target_type": "individual"
    },
    {
      "word": "のろま",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ノロマ",
        "noroma"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'slowpoke' or 'dunce'. Hiragana: のろま, Katakana: ノロマ, Romaji: noroma",
      "target_type": "individual"
    },
    {
      "word": "低脳",
      "severity": 2,
      "categories": [
        "general",
        "insult",
        "ableist"
      ],
      "variations": [
        "ていのう",
        "teinou"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'low intelligence', ableist connotation. Hiragana: ていのう, Kanji: 低脳, Romaji: teinou",
      "target_type": "individual"
    },
    {
      "word": "白痴",
      "severity": 3,
      "categories": [
        "insult",
        "ableist"
      ],
      "variations": [
        "ハクチ",
        "はくち",
        "hakuchi"
      ],
      "case_sensitive": false,
      "context_notes": "Medical term for mental disability used as severe insult. Hiragana: はくち, Katakana: ハクチ, Kanji: 白痴, Romaji: hakuchi",
      "target_type": "individual"
    },
    {
      "word": "愚か者",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "おろかもの",
        "orokamono"
      ],
      "case_sensitive": false,
      "context_notes": "Formal term meaning 'foolish person'. Hiragana: おろかもの, Kanji: 愚か者, Romaji: orokamono",
      "target_type": "individual"
    },
    {
      "word": "ブス",
      "severity": 2,
      "categories": [
        "appearance",
        "slurs"
      ],
      "variations": [
        "ぶす",
        "busu"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for ugly woman, quite hurtful. Hiragana: ぶす, Katakana: ブス, Romaji: busu",
      "target_type": "individual"
    },
    {
      "word": "ブサイク",
      "severity": 2,
      "categories": [
        "appearance",
        "slurs"
      ],
      "variations": [
        "ぶさいく",
        "busaiku",
        "不細工"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'ugly' or 'unattractive'. Hiragana: ぶさいく, Katakana: ブサイク, Kanji: 不細工, Romaji: busaiku",
      "target_type": "individual"
    },
    {
      "word": "デブ",
      "severity": 2,
      "categories": [
        "appearance",
        "slurs"
      ],
      "variations": [
        "でぶ",
        "debu"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for fat person, considered bullying. Hiragana: でぶ, Katakana: デブ, Romaji: debu",
      "target_type": "individual"
    },
    {
      "word": "豚",
      "severity": 2,
      "categories": [
        "appearance",
        "slurs"
      ],
      "variations": [
        "ブタ",
        "ぶた",
        "buta"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'pig', used to insult overweight people. Hiragana: ぶた, Katakana: ブタ, Kanji: 豚, Romaji: buta",
      "target_type": "individual"
    },
    {
      "word": "ゴリラ",
      "severity": 2,
      "categories": [
        "appearance",
        "slurs"
      ],
      "variations": [
        "ごりら",
        "gorira"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'gorilla', used for big or violent people. Hiragana: ごりら, Katakana: ゴリラ, Romaji: gorira",
      "target_type": "individual"
    },
    {
      "word": "猿",
      "severity": 2,
      "categories": [
        "appearance",
        "ethnic"
      ],
      "variations": [
        "サル",
        "さる",
        "saru"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'monkey', derogatory term. Hiragana: さる, Katakana: サル, Kanji: 猿, Romaji: saru",
      "target_type": "individual"
    },
    {
      "word": "化け物",
      "severity": 2,
      "categories": [
        "appearance",
        "insult"
      ],
      "variations": [
        "バケモノ",
        "ばけもの",
        "bakemono"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'monster' or 'freak'. Hiragana: ばけもの, Katakana: バケモノ, Kanji: 化け物, Romaji: bakemono",
      "target_type": "individual"
    },
    {
      "word": "ハゲ",
      "severity": 2,
      "categories": [
        "appearance",
        "slurs"
      ],
      "variations": [
        "はげ",
        "hage"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'baldy' or 'bald person'. Hiragana: はげ, Katakana: ハゲ, Romaji: hage",
      "target_type": "individual"
    },
    {
      "word": "チビ",
      "severity": 2,
      "categories": [
        "appearance",
        "slurs"
      ],
      "variations": [
        "ちび",
        "chibi"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'shorty' or 'small person'. Hiragana: ちび, Katakana: チビ, Romaji: chibi",
      "target_type": "individual"
    },
    {
      "word": "醜い",
      "severity": 2,
      "categories": [
        "appearance",
        "insult"
      ],
      "variations": [
        "みにくい",
        "minikui"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'ugly' or 'hideous'. Hiragana: みにくい, Kanji: 醜い, Romaji: minikui",
      "target_type": "individual"
    },
    {
      "word": "きもい",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "キモイ",
        "kimoi",
        "気持ち悪い",
        "kimochi warui",
        "キモい"
      ],
      "case_sensitive": false,
      "context_notes": "Slang for 'gross' or 'disgusting', from 'kimochi warui'. Hiragana: きもい, Katakana: キモイ, Full form: 気持ち悪い, Romaji: kimoi",
      "target_type": "individual"
    },
    {
      "word": "クサイ",
      "severity": 1,
      "categories": [
        "appearance",
        "insult"
      ],
      "variations": [
        "くさい",
        "kusai"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'smelly' or 'stinky'. Hiragana: くさい, Katakana: クサイ, Romaji: kusai",
      "target_type": "individual"
    },
    {
      "word": "汚い",
      "severity": 1,
      "categories": [
        "appearance",
        "insult"
      ],
      "variations": [
        "きたない",
        "kitanai"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'dirty' or 'filthy'. Hiragana: きたない, Kanji: 汚い, Romaji: kitanai",
      "target_type": "individual"
    },
    {
      "word": "貴様",
      "severity": 3,
      "categories": [
        "general",
        "pronouns"
      ],
      "variations": [
        "キサマ",
        "きさま",
        "kisama"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely rude pronoun 'you', was once respectful but became hostile. Hiragana: きさま, Katakana: キサマ, Kanji: 貴様, Romaji: kisama",
      "target_type": "individual"
    },
    {
      "word": "手前",
      "severity": 3,
      "categories": [
        "general",
        "pronouns"
      ],
      "variations": [
        "てめえ",
        "テメエ",
        "temee"
      ],
      "case_sensitive": false,
      "context_notes": "Hostile pronoun meaning 'you bastard'. Hiragana: てめえ, Katakana: テメエ, Kanji: 手前, Romaji: temee",
      "target_type": "individual"
    },
    {
      "word": "お前",
      "severity": 2,
      "categories": [
        "general",
        "pronouns"
      ],
      "variations": [
        "オマエ",
        "おまえ",
        "omae"
      ],
      "case_sensitive": false,
      "context_notes": "Rude/casual pronoun 'you'. Hiragana: おまえ, Katakana: オマエ, Kanji: お前, Romaji: omae",
      "target_type": "individual"
    },
    {
      "word": "奴",
      "severity": 2,
      "categories": [
        "general",
        "pronouns"
      ],
      "variations": [
        "ヤツ",
        "やつ",
        "yatsu"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory third person 'that guy'. Hiragana: やつ, Katakana: ヤツ, Kanji: 奴, Romaji: yatsu",
      "target_type": "individual"
    },
    {
      "word": "こいつ",
      "severity": 2,
      "categories": [
        "general",
        "pronouns"
      ],
      "variations": [
        "コイツ",
        "koitsu"
      ],
      "case_sensitive": false,
      "context_notes": "Rude demonstrative 'this guy'. Hiragana: こいつ, Katakana: コイツ, Romaji: koitsu",
      "target_type": "individual"
    },
    {
      "word": "あいつ",
      "severity": 2,
      "categories": [
        "general",
        "pronouns"
      ],
      "variations": [
        "アイツ",
        "aitsu"
      ],
      "case_sensitive": false,
      "context_notes": "Rude demonstrative 'that guy'. Hiragana: あいつ, Katakana: アイツ, Romaji: aitsu",
      "target_type": "individual"
    },
    {
      "word": "そいつ",
      "severity": 2,
      "categories": [
        "general",
        "pronouns"
      ],
      "variations": [
        "ソイツ",
        "soitsu"
      ],
      "case_sensitive": false,
      "context_notes": "Rude demonstrative 'that person'. Hiragana: そいつ, Katakana: ソイツ, Romaji: soitsu",
      "target_type": "individual"
    },
    {
      "word": "野郎",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ヤロウ",
        "やろう",
        "yarou"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'bastard' or 'jerk'. Hiragana: やろう, Katakana: ヤロウ, Kanji: 野郎, Romaji: yarou",
      "target_type": "individual"
    },
    {
      "word": "下衆野郎",
      "severity": 3,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "げすやろう",
        "gesuyarou"
      ],
      "case_sensitive": false,
      "context_notes": "Compound profanity meaning 'lowlife asshole'. Hiragana: げすやろう, Kanji: 下衆野郎, Romaji: gesuyarou",
      "target_type": "individual"
    },
    {
      "word": "死ね",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "シネ",
        "しね",
        "shine",
        "氏ね"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive command meaning 'die', considered very serious threat. Hiragana: しね, Katakana: シネ, Kanji: 死ね, Internet variant: 氏ね, Romaji: shine",
      "target_type": "individual"
    },
    {
      "word": "死んじまえ",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "しんじまえ",
        "shinjimae"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive command meaning 'drop dead'. Hiragana: しんじまえ, Kanji: 死んじまえ, Romaji: shinjimae",
      "target_type": "individual"
    },
    {
      "word": "殺す",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "コロス",
        "ころす",
        "korosu"
      ],
      "case_sensitive": false,
      "context_notes": "Verb meaning 'to kill', extremely serious when directed at person. Hiragana: ころす, Katakana: コロス, Kanji: 殺す, Romaji: korosu",
      "target_type": "individual"
    },
    {
      "word": "殺すぞ",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "ころすぞ",
        "korosu zo"
      ],
      "case_sensitive": false,
      "context_notes": "Explicit death threat meaning 'I'll kill you'. Hiragana: ころすぞ, Kanji: 殺すぞ, Romaji: korosu zo",
      "target_type": "individual"
    },
    {
      "word": "黙れ",
      "severity": 2,
      "categories": [
        "general",
        "commands"
      ],
      "variations": [
        "ダマレ",
        "だまれ",
        "damare"
      ],
      "case_sensitive": false,
      "context_notes": "Harsh command meaning 'shut up'. Hiragana: だまれ, Katakana: ダマレ, Kanji: 黙れ, Romaji: damare",
      "target_type": "individual"
    },
    {
      "word": "うるさい",
      "severity": 2,
      "categories": [
        "general",
        "commands"
      ],
      "variations": [
        "ウルサイ",
        "urusai",
        "五月蝿い"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'shut up' or 'noisy', rude command. Hiragana: うるさい, Katakana: ウルサイ, Kanji: 五月蝿い, Romaji: urusai",
      "target_type": "individual"
    },
    {
      "word": "どけ",
      "severity": 2,
      "categories": [
        "general",
        "commands"
      ],
      "variations": [
        "ドケ",
        "doke"
      ],
      "case_sensitive": false,
      "context_notes": "Harsh command meaning 'get out of my way'. Hiragana: どけ, Katakana: ドケ, Romaji: doke",
      "target_type": "individual"
    },
    {
      "word": "失せろ",
      "severity": 3,
      "categories": [
        "general",
        "commands"
      ],
      "variations": [
        "うせろ",
        "usero"
      ],
      "case_sensitive": false,
      "context_notes": "Harsh command meaning 'get lost' or 'piss off'. Hiragana: うせろ, Kanji: 失せろ, Romaji: usero",
      "target_type": "individual"
    },
    {
      "word": "消えろ",
      "severity": 3,
      "categories": [
        "general",
        "commands"
      ],
      "variations": [
        "きえろ",
        "kiero"
      ],
      "case_sensitive": false,
      "context_notes": "Harsh command meaning 'disappear' or 'get lost'. Hiragana: きえろ, Kanji: 消えろ, Romaji: kiero",
      "target_type": "individual"
    },
    {
      "word": "変態",
      "severity": 2,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "ヘンタイ",
        "へんたい",
        "hentai"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'pervert', also known in Western culture through anime. Hiragana: へんたい, Katakana: ヘンタイ, Kanji: 変態, Romaji: hentai",
      "target_type": "individual"
    },
    {
      "word": "スケベ",
      "severity": 2,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "すけべ",
        "sukebe",
        "助平"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'lecher' or 'pervert'. Hiragana: すけべ, Katakana: スケベ, Kanji: 助平, Romaji: sukebe",
      "target_type": "individual"
    },
    {
      "word": "エロ",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "えろ",
        "ero"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'perverted' or 'sexual', from English 'erotic'. Hiragana: えろ, Katakana: エロ, Romaji: ero",
      "target_type": "general"
    },
    {
      "word": "エッチ",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "えっち",
        "ecchi"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'lewd', 'naughty', or 'sex', from letter 'H'. Hiragana: えっち, Katakana: エッチ, Romaji: ecchi",
      "target_type": "general"
    },
    {
      "word": "やりまん",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "ヤリマン",
        "yariman"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory term for promiscuous woman, means 'slut'. Hiragana: やりまん, Katakana: ヤリマン, Romaji: yariman",
      "target_type": "individual"
    },
    {
      "word": "やりちん",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "ヤリチン",
        "yarichin"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for promiscuous man, means 'man-whore'. Hiragana: やりちん, Katakana: ヤリチン, Romaji: yarichin",
      "target_type": "individual"
    },
    {
      "word": "淫売",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "インバイ",
        "いんばい",
        "inbai"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for prostitute, highly offensive to women. Hiragana: いんばい, Katakana: インバイ, Kanji: 淫売, Romaji: inbai",
      "target_type": "individual"
    },
    {
      "word": "売春婦",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "ばいしゅんふ",
        "baishunfu"
      ],
      "case_sensitive": false,
      "context_notes": "Term for prostitute, offensive when used as insult. Hiragana: ばいしゅんふ, Kanji: 売春婦, Romaji: baishunfu",
      "target_type": "individual"
    },
    {
      "word": "娼婦",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "しょうふ",
        "shoufu"
      ],
      "case_sensitive": false,
      "context_notes": "Term for prostitute, offensive when used as insult. Hiragana: しょうふ, Kanji: 娼婦, Romaji: shoufu",
      "target_type": "individual"
    },
    {
      "word": "女郎",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "じょろう",
        "jorou"
      ],
      "case_sensitive": false,
      "context_notes": "Archaic term for prostitute. Hiragana: じょろう, Kanji: 女郎, Romaji: jorou",
      "target_type": "individual"
    },
    {
      "word": "尻軽",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "しりがる",
        "shirigaru"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'easy woman' or 'promiscuous'. Hiragana: しりがる, Kanji: 尻軽, Romaji: shirigaru",
      "target_type": "individual"
    },
    {
      "word": "遊び人",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "あそびにん",
        "asobinin"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'player' or 'womanizer'. Hiragana: あそびにん, Kanji: 遊び人, Romaji: asobinin",
      "target_type": "individual"
    },
    {
      "word": "あばずれ",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "アバズレ",
        "abazure"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive term meaning 'bitch' or 'slut'. Hiragana: あばずれ, Katakana: アバズレ, Romaji: abazure",
      "target_type": "individual"
    },
    {
      "word": "ちんこ",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "チンコ",
        "chinko"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for penis/dick, childish/crude. Hiragana: ちんこ, Katakana: チンコ, Romaji: chinko",
      "target_type": "general"
    },
    {
      "word": "ちんぽ",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "チンポ",
        "chinpo",
        "ちんぽこ",
        "chinpoko"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for penis/dick. Hiragana: ちんぽ/ちんぽこ, Katakana: チンポ, Romaji: chinpo",
      "target_type": "general"
    },
    {
      "word": "まら",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "マラ",
        "mara"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar Buddhist term for penis. Hiragana: まら, Katakana: マラ, Romaji: mara",
      "target_type": "general"
    },
    {
      "word": "金玉",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "キンタマ",
        "きんたま",
        "kintama",
        "タマ",
        "tama"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for testicles/balls. Hiragana: きんたま, Katakana: キンタマ, Kanji: 金玉, Shortened: タマ, Romaji: kintama",
      "target_type": "general"
    },
    {
      "word": "まんこ",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "マンコ",
        "manko"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for vagina/cunt, highly offensive. Hiragana: まんこ, Katakana: マンコ, Romaji: manko",
      "target_type": "general"
    },
    {
      "word": "おまんこ",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "オマンコ",
        "omanko"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for vagina/cunt with honorific prefix, highly offensive. Hiragana: おまんこ, Katakana: オマンコ, Romaji: omanko",
      "target_type": "general"
    },
    {
      "word": "おっぱい",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "オッパイ",
        "oppai"
      ],
      "case_sensitive": false,
      "context_notes": "Casual/vulgar term for breasts/boobs. Hiragana: おっぱい, Katakana: オッパイ, Romaji: oppai",
      "target_type": "general"
    },
    {
      "word": "乳",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "ちち",
        "chichi"
      ],
      "case_sensitive": false,
      "context_notes": "Term for breasts/tits, can be vulgar in context. Hiragana: ちち, Kanji: 乳, Romaji: chichi",
      "target_type": "general"
    },
    {
      "word": "おちんちん",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "オチンチン",
        "ochinchin"
      ],
      "case_sensitive": false,
      "context_notes": "Childish term for penis with honorific prefix. Hiragana: おちんちん, Katakana: オチンチン, Romaji: ochinchin",
      "target_type": "general"
    },
    {
      "word": "けつ",
      "severity": 1,
      "categories": [
        "body_parts"
      ],
      "variations": [
        "ケツ",
        "ketsu",
        "尻",
        "shiri"
      ],
      "case_sensitive": false,
      "context_notes": "Casual/vulgar term for ass/butt. Hiragana: けつ, Katakana: ケツ, Kanji: 尻, Romaji: ketsu",
      "target_type": "general"
    },
    {
      "word": "けつの穴",
      "severity": 2,
      "categories": [
        "body_parts"
      ],
      "variations": [
        "ケツの穴",
        "ketsu no ana"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for asshole. Hiragana: けつのあな, Katakana/Mixed: ケツの穴, Romaji: ketsu no ana",
      "target_type": "general"
    },
    {
      "word": "肛門",
      "severity": 1,
      "categories": [
        "body_parts"
      ],
      "variations": [
        "こうもん",
        "koumon"
      ],
      "case_sensitive": false,
      "context_notes": "Clinical term for anus. Hiragana: こうもん, Kanji: 肛門, Romaji: koumon",
      "target_type": "general"
    },
    {
      "word": "うんこ",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "ウンコ",
        "unko"
      ],
      "case_sensitive": false,
      "context_notes": "Childish/casual term for shit/poop. Hiragana: うんこ, Katakana: ウンコ, Romaji: unko",
      "target_type": "general"
    },
    {
      "word": "大便",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "だいべん",
        "daiben"
      ],
      "case_sensitive": false,
      "context_notes": "Clinical term for feces. Hiragana: だいべん, Kanji: 大便, Romaji: daiben",
      "target_type": "general"
    },
    {
      "word": "小便",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "しょうべん",
        "shouben",
        "しょんべん",
        "shonben",
        "ションベン"
      ],
      "case_sensitive": false,
      "context_notes": "Casual term for urine/piss. Hiragana: しょうべん/しょんべん, Katakana: ションベン, Kanji: 小便, Romaji: shouben/shonben",
      "target_type": "general"
    },
    {
      "word": "おしっこ",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "オシッコ",
        "oshikko"
      ],
      "case_sensitive": false,
      "context_notes": "Childish term for pee/urine. Hiragana: おしっこ, Katakana: オシッコ, Romaji: oshikko",
      "target_type": "general"
    },
    {
      "word": "うざい",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ウザイ",
        "uzai"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang meaning 'annoying' or 'irritating'. Hiragana: うざい, Katakana: ウザイ, Romaji: uzai",
      "target_type": "individual"
    },
    {
      "word": "うざったい",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ウザったい",
        "uzattai"
      ],
      "case_sensitive": false,
      "context_notes": "Intensified form meaning 'super annoying'. Hiragana: うざったい, Katakana/Mixed: ウザったい, Romaji: uzattai",
      "target_type": "individual"
    },
    {
      "word": "むかつく",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ムカつく",
        "mukatsuku"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'irritating' or 'pisses me off'. Hiragana: むかつく, Katakana/Mixed: ムカつく, Romaji: mukatsuku",
      "target_type": "general"
    },
    {
      "word": "腹立つ",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "はらたつ",
        "hara tatsu"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'makes me angry'. Hiragana: はらたつ, Kanji: 腹立つ, Romaji: hara tatsu",
      "target_type": "general"
    },
    {
      "word": "嘘つき",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ウソツキ",
        "うそつき",
        "usotsuki"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'liar'. Hiragana: うそつき, Katakana: ウソツキ, Kanji: 嘘つき, Romaji: usotsuki",
      "target_type": "individual"
    },
    {
      "word": "卑怯",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ひきょう",
        "hikyou"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'coward' or 'cowardly'. Hiragana: ひきょう, Kanji: 卑怯, Romaji: hikyou",
      "target_type": "individual"
    },
    {
      "word": "弱虫",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ヨワムシ",
        "よわむし",
        "yowamushi"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'weakling' or 'coward'. Hiragana: よわむし, Katakana: ヨワムシ, Kanji: 弱虫, Romaji: yowamushi",
      "target_type": "individual"
    },
    {
      "word": "腰抜け",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "こしぬけ",
        "koshinuke"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'coward', literally 'one who loses their hips/backbone'. Hiragana: こしぬけ, Kanji: 腰抜け, Romaji: koshinuke",
      "target_type": "individual"
    },
    {
      "word": "臆病者",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "おくびょうもの",
        "okubyoumono"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'coward'. Hiragana: おくびょうもの, Kanji: 臆病者, Romaji: okubyoumono",
      "target_type": "individual"
    },
    {
      "word": "けち",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ケチ",
        "kechi"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'stingy' or 'cheap'. Hiragana: けち, Katakana: ケチ, Romaji: kechi",
      "target_type": "individual"
    },
    {
      "word": "ずるい",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ズルい",
        "zurui"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'unfair' or 'sneaky'. Hiragana: ずるい, Katakana/Mixed: ズルい, Romaji: zurui",
      "target_type": "individual"
    },
    {
      "word": "ダサい",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ださ",
        "dasai",
        "dasa"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'lame' or 'uncool'. Katakana: ダサい, Hiragana: ださい, Romaji: dasai",
      "target_type": "individual"
    },
    {
      "word": "クズ",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "くず",
        "kuzu",
        "屑"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'trash' or 'scum'. Hiragana: くず, Katakana: クズ, Kanji: 屑, Romaji: kuzu",
      "target_type": "individual"
    },
    {
      "word": "カス",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "かす",
        "kasu",
        "滓"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'scum' or 'worthless'. Hiragana: かす, Katakana: カス, Kanji: 滓, Romaji: kasu",
      "target_type": "individual"
    },
    {
      "word": "ゴミ",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ごみ",
        "gomi"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'garbage' or 'trash'. Hiragana: ごみ, Katakana: ゴミ, Romaji: gomi",
      "target_type": "individual"
    },
    {
      "word": "塵",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ちり",
        "chiri"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'dust' or 'trash', literary insult. Hiragana: ちり, Kanji: 塵, Romaji: chiri",
      "target_type": "individual"
    },
    {
      "word": "ガキ",
      "severity": 2,
      "categories": [
        "general",
        "age"
      ],
      "variations": [
        "がき",
        "gaki",
        "餓鬼"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for brat/kid. Hiragana: がき, Katakana: ガキ, Kanji: 餓鬼, Romaji: gaki",
      "target_type": "individual"
    },
    {
      "word": "糞ガキ",
      "severity": 3,
      "categories": [
        "general",
        "age"
      ],
      "variations": [
        "くそガキ",
        "kusogaki"
      ],
      "case_sensitive": false,
      "context_notes": "Compound profanity meaning 'little brat' or 'shitty kid'. Hiragana: くそがき, Katakana/Mixed: 糞ガキ, Romaji: kusogaki",
      "target_type": "individual"
    },
    {
      "word": "じじい",
      "severity": 2,
      "categories": [
        "general",
        "age"
      ],
      "variations": [
        "ジジイ",
        "jijii",
        "爺"
      ],
      "case_sensitive": false,
      "context_notes": "Rude term for old man. Hiragana: じじい, Katakana: ジジイ, Kanji: 爺, Romaji: jijii",
      "target_type": "individual"
    },
    {
      "word": "くそじじい",
      "severity": 3,
      "categories": [
        "general",
        "age"
      ],
      "variations": [
        "クソジジイ",
        "kusojijii"
      ],
      "case_sensitive": false,
      "context_notes": "Compound profanity meaning 'old fart'. Hiragana: くそじじい, Katakana: クソジジイ, Romaji: kusojijii",
      "target_type": "individual"
    },
    {
      "word": "ばばあ",
      "severity": 2,
      "categories": [
        "general",
        "age"
      ],
      "variations": [
        "ババア",
        "babaa",
        "婆"
      ],
      "case_sensitive": false,
      "context_notes": "Rude term for old woman/hag. Hiragana: ばばあ, Katakana: ババア, Kanji: 婆, Romaji: babaa",
      "target_type": "individual"
    },
    {
      "word": "くそばばあ",
      "severity": 3,
      "categories": [
        "general",
        "age"
      ],
      "variations": [
        "クソババア",
        "kusobabaa"
      ],
      "case_sensitive": false,
      "context_notes": "Compound profanity meaning 'old hag'. Hiragana: くそばばあ, Katakana: クソババア, Romaji: kusobabaa",
      "target_type": "individual"
    },
    {
      "word": "チョン",
      "severity": 4,
      "categories": [
        "ethnic",
        "hate_speech"
      ],
      "variations": [
        "ちょん",
        "chon"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive ethnic slur against Koreans, banned from broadcast. Hiragana: ちょん, Katakana: チョン, Romaji: chon",
      "target_type": "group"
    },
    {
      "word": "朝鮮人",
      "severity": 3,
      "categories": [
        "ethnic",
        "hate_speech"
      ],
      "variations": [
        "チョウセンジン",
        "ちょうせんじん",
        "chousenjin"
      ],
      "case_sensitive": false,
      "context_notes": "When used derogatorily, becomes ethnic slur against Koreans. Hiragana: ちょうせんじん, Katakana: チョウセンジン, Kanji: 朝鮮人, Romaji: chousenjin",
      "target_type": "group"
    },
    {
      "word": "支那",
      "severity": 3,
      "categories": [
        "ethnic",
        "hate_speech"
      ],
      "variations": [
        "シナ",
        "しな",
        "shina"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory historical term for China, now considered offensive. Hiragana: しな, Katakana: シナ, Kanji: 支那, Romaji: shina",
      "target_type": "group"
    },
    {
      "word": "毛唐",
      "severity": 4,
      "categories": [
        "ethnic",
        "hate_speech"
      ],
      "variations": [
        "けとう",
        "ketou"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive slur meaning 'hairy barbarian', used for Westerners. Hiragana: けとう, Kanji: 毛唐, Romaji: ketou",
      "target_type": "group"
    },
    {
      "word": "外人",
      "severity": 1,
      "categories": [
        "ethnic"
      ],
      "variations": [
        "ガイジン",
        "がいじん",
        "gaijin"
      ],
      "case_sensitive": false,
      "context_notes": "Term for foreigner, can be neutral or derogatory depending on context. Hiragana: がいじん, Katakana: ガイジン, Kanji: 外人, Romaji: gaijin",
      "target_type": "group"
    },
    {
      "word": "おかま",
      "severity": 2,
      "categories": [
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "オカマ",
        "okama"
      ],
      "case_sensitive": false,
      "context_notes": "Term for effeminate man or drag queen, can be derogatory depending on context. Hiragana: おかま, Katakana: オカマ, Romaji: okama",
      "target_type": "individual"
    },
    {
      "word": "ホモ",
      "severity": 2,
      "categories": [
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "ほも",
        "homo"
      ],
      "case_sensitive": false,
      "context_notes": "Shortened form of homosexual, often used derogatorily. Hiragana: ほも, Katakana: ホモ, Romaji: homo",
      "target_type": "individual"
    },
    {
      "word": "レズ",
      "severity": 2,
      "categories": [
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "れず",
        "rezu"
      ],
      "case_sensitive": false,
      "context_notes": "Shortened form of lesbian, often used derogatorily. Hiragana: れず, Katakana: レズ, Romaji: rezu",
      "target_type": "individual"
    },
    {
      "word": "オネエ",
      "severity": 1,
      "categories": [
        "lgbtq"
      ],
      "variations": [
        "おねえ",
        "onee"
      ],
      "case_sensitive": false,
      "context_notes": "Term for effeminate man, can be neutral or derogatory. Hiragana: おねえ, Katakana: オネエ, Romaji: onee",
      "target_type": "individual"
    },
    {
      "word": "基地外",
      "severity": 4,
      "categories": [
        "ableist",
        "hate_speech"
      ],
      "variations": [
        "キチガイ",
        "きちがい",
        "kichigai",
        "気違い"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive term for mentally ill person, banned from media. Hiragana: きちがい, Katakana: キチガイ, Kanji: 基地外/気違い, Romaji: kichigai",
      "target_type": "individual"
    },
    {
      "word": "池沼",
      "severity": 4,
      "categories": [
        "ableist",
        "hate_speech"
      ],
      "variations": [
        "イケショウ",
        "いけしょう",
        "ikeshou"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang abbreviation for mental disability, extremely offensive, banned from broadcast. Hiragana: いけしょう, Katakana: イケショウ, Kanji: 池沼, Romaji: ikeshou",
      "target_type": "individual"
    },
    {
      "word": "知恵遅れ",
      "severity": 3,
      "categories": [
        "ableist"
      ],
      "variations": [
        "ちえおくれ",
        "chieokure"
      ],
      "case_sensitive": false,
      "context_notes": "Ableist term meaning 'mentally retarded'. Hiragana: ちえおくれ, Kanji: 知恵遅れ, Romaji: chieokure",
      "target_type": "individual"
    },
    {
      "word": "障害者",
      "severity": 1,
      "categories": [
        "ableist"
      ],
      "variations": [
        "しょうがいしゃ",
        "shougaisha"
      ],
      "case_sensitive": false,
      "context_notes": "Term for disabled person, neutral in proper context but offensive when used as insult. Hiragana: しょうがいしゃ, Kanji: 障害者, Romaji: shougaisha",
      "target_type": "individual"
    },
    {
      "word": "カタワ",
      "severity": 4,
      "categories": [
        "ableist",
        "hate_speech"
      ],
      "variations": [
        "かたわ",
        "katawa",
        "片輪"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive slur for cripple/disabled person, banned from broadcast. Hiragana: かたわ, Katakana: カタワ, Kanji: 片輪, Romaji: katawa",
      "target_type": "individual"
    },
    {
      "word": "びっこ",
      "severity": 4,
      "categories": [
        "ableist",
        "hate_speech"
      ],
      "variations": [
        "ビッコ",
        "bikko",
        "跛"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive slur meaning 'lame' or 'cripple', banned from broadcast. Hiragana: びっこ, Katakana: ビッコ, Kanji: 跛, Romaji: bikko",
      "target_type": "individual"
    },
    {
      "word": "メクラ",
      "severity": 4,
      "categories": [
        "ableist",
        "hate_speech"
      ],
      "variations": [
        "めくら",
        "mekura",
        "盲"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive slur for blind person, banned from broadcast. Hiragana: めくら, Katakana: メクラ, Kanji: 盲, Romaji: mekura",
      "target_type": "individual"
    },
    {
      "word": "つんぼ",
      "severity": 4,
      "categories": [
        "ableist",
        "hate_speech"
      ],
      "variations": [
        "ツンボ",
        "tsunbo"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive slur for deaf person, banned from broadcast. Hiragana: つんぼ, Katakana: ツンボ, Romaji: tsunbo",
      "target_type": "individual"
    },
    {
      "word": "DQN",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ドキュン",
        "dokyun"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang for delinquent or troublemaker, from TV show name. Katakana: ドキュン, Romaji: DQN/dokyun",
      "target_type": "individual"
    },
    {
      "word": "厨房",
      "severity": 1,
      "categories": [
        "general",
        "age"
      ],
      "variations": [
        "チュウボウ",
        "ちゅうぼう",
        "chuubou",
        "厨"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang meaning 'middle schooler', implies immaturity. Hiragana: ちゅうぼう, Katakana: チュウボウ, Kanji: 厨房, Shortened: 厨, Romaji: chuubou",
      "target_type": "individual"
    },
    {
      "word": "ゆとり",
      "severity": 1,
      "categories": [
        "general",
        "generational"
      ],
      "variations": [
        "ユトリ",
        "yutori"
      ],
      "case_sensitive": false,
      "context_notes": "Refers to generation with 'relaxed education', implies laziness. Hiragana: ゆとり, Katakana: ユトリ, Romaji: yutori",
      "target_type": "group"
    },
    {
      "word": "情弱",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "じょうじゃく",
        "joujaku"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang meaning 'information-poor' or 'uninformed'. Hiragana: じょうじゃく, Kanji: 情弱, Romaji: joujaku",
      "target_type": "individual"
    },
    {
      "word": "リア充",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "りあじゅう",
        "riajuu"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang meaning 'normie', can be derogatory in some contexts. Hiragana: りあじゅう, Katakana/Kanji: リア充, Romaji: riajuu",
      "target_type": "individual"
    },
    {
      "word": "陰キャ",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "いんきゃ",
        "inkya"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang for introverted loser. Hiragana: いんきゃ, Kanji: 陰キャ, Romaji: inkya",
      "target_type": "individual"
    },
    {
      "word": "陽キャ",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "ようきゃ",
        "youkya"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang for extroverted person, can be negative in some contexts. Hiragana: ようきゃ, Kanji: 陽キャ, Romaji: youkya",
      "target_type": "individual"
    },
    {
      "word": "キョロ充",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "きょろじゅう",
        "kyorojuu"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang meaning 'fake normie'. Hiragana: きょろじゅう, Katakana/Kanji: キョロ充, Romaji: kyorojuu",
      "target_type": "individual"
    },
    {
      "word": "ディスる",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "でぃする",
        "disuru"
      ],
      "case_sensitive": false,
      "context_notes": "Modern slang verb meaning 'to diss' or 'insult', from English. Hiragana: でぃする, Katakana: ディスる, Romaji: disuru",
      "target_type": "general"
    },
    {
      "word": "童貞",
      "severity": 1,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "ドウテイ",
        "どうてい",
        "doutei"
      ],
      "case_sensitive": false,
      "context_notes": "Term for male virgin, used mockingly in internet culture. Hiragana: どうてい, Katakana: ドウテイ, Kanji: 童貞, Romaji: doutei",
      "target_type": "individual"
    },
    {
      "word": "処女",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ショジョ",
        "しょじょ",
        "shojo"
      ],
      "case_sensitive": false,
      "context_notes": "Term for female virgin, less commonly used as insult than doutei. Hiragana: しょじょ, Katakana: ショジョ, Kanji: 処女, Romaji: shojo",
      "target_type": "individual"
    },
    {
      "word": "やばい",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "ヤバイ",
        "yabai",
        "やば",
        "yaba"
      ],
      "case_sensitive": false,
      "context_notes": "Originally meant 'dangerous' but now used as 'awesome/terrible' depending on context. Hiragana: やばい, Katakana: ヤバイ, Romaji: yabai",
      "target_type": "general"
    },
    {
      "word": "めんどくさい",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "メンドクサイ",
        "mendokusai",
        "めんどい",
        "mendoi"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'troublesome' or 'bothersome', mildly rude. Hiragana: めんどくさい, Katakana: メンドクサイ, Romaji: mendokusai",
      "target_type": "general"
    }
  ]
} as const

export type JAType = typeof JA
